import styled from '@emotion/styled';
import { Space } from 'antd';
import JobStatus, { STATUS_TYPE } from 'app/components/Status/JobStatus';
import React from 'react';

const StyledNotedStatus = styled.span`
  margin-top: 16px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0.002em;
  text-align: justified;

  color: ${(props: any) => {
    return props.color;
  }};
`;

const StatusDescriptions = (props: {
  descriptions: Array<{
    color: string;
    status: STATUS_TYPE;
    label: string;
    description: string;
  }>;
}) => {
  const { descriptions } = props;
  return (
    <Space size={60}>
      {descriptions.map((des, index) => {
        return (
          <StyledNotedStatus key={index} color={des.color}>
            <JobStatus style={{ fontSize: 10 }} alpha={1} status={des.status}>
              {des.label}
            </JobStatus>
            {des.description}
          </StyledNotedStatus>
        );
      })}
    </Space>
  );
};

export default StatusDescriptions;
